import { render, staticRenderFns } from "./TopRanking.vue?vue&type=template&id=2dc67b9c&scoped=true&"
import script from "./TopRanking.vue?vue&type=script&lang=js&"
export * from "./TopRanking.vue?vue&type=script&lang=js&"
import style0 from "./TopRanking.vue?vue&type=style&index=0&id=2dc67b9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc67b9c",
  null
  
)

export default component.exports